import { render, staticRenderFns } from "./AppListConfig.vue?vue&type=template&id=044a61a2&scoped=true"
import script from "./AppListConfig.vue?vue&type=script&lang=js"
export * from "./AppListConfig.vue?vue&type=script&lang=js"
import style0 from "./AppListConfig.vue?vue&type=style&index=0&id=044a61a2&prod&lang=scss"
import style1 from "./AppListConfig.vue?vue&type=style&index=1&id=044a61a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a61a2",
  null
  
)

export default component.exports